import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const BatteryCapacity = ({ batteryCapacity }: SpecProps<"battery_capacity">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (batteryCapacity == null || batteryCapacity === 0) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.battery_capacity",
    message: "Battery capacity",
    comment: "Field for 'battery capacity' in ad specification",
  });

  const value = i18n.t({
    id: "itemPageLayout.keyInfo.battery_capacity.postfix",
    message: "{capacity} kWh",
    comment: "Battery capacity postfix in ad specification",
    values: { capacity: formatNumber(batteryCapacity, locale) },
  });
  return <FieldValuePair field={field} value={value} />;
};
